import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Skeleton } from 'native-base';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../../../components/TableContent';
import { getFlex } from '../../utils';

export const SecondCopyListLoadingDesktop: React.FC = () => {
  return (
    <TableContent
      direction="row"
      space={Spacing['stack.quarck']}
      py={Spacing['stack.xxs']}
      px={Spacing['inline.xxxs']}
      spaceX={Spacing['inline.xxxs']}>
      <TableContentItemColumn flex={getFlex(0)}>
        <TableContentItemText>
          <Skeleton flex={1} height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} />
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(1)}>
        <TableContentItemText>
          <Skeleton flex={1} height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} />
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(2)}>
        <TableContentItemText>
          <Skeleton flex={1} height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} />
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(3)}>
        <TableContentItemText>
          <Skeleton flex={1} height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} />
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(4)}>
        <TableContentItemText>
          <Skeleton flex={1} height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} />
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(5)}>
        <TableContentItemText>
          <Skeleton flex={1} height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} />
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(6)}>
        <TableContentItemText>
          <Skeleton flex={1} height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} />
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(7)}>
        <TableContentItemText>
          <Skeleton flex={1} height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} />
        </TableContentItemText>
      </TableContentItemColumn>
      <TableContentItemColumn flex={getFlex(8)}>
        <TableContentItemText>
          <Skeleton flex={1} height={Spacing['inline.xxs']} borderRadius={BoxRadius.sm} />
        </TableContentItemText>
      </TableContentItemColumn>
    </TableContent>
  );
};
